import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable({ providedIn: 'root' })
export class ProductsPromoAnalytics extends AnalyticsBase {
  public readonly namespace = 'ProductsPromo';
  public readonly requireViewContext = false;

  public trackTooltipEvents(
    eventName: string,
    productContext: 'kiwiHr' | 'journeys',
    context: 'candidateProfile' | 'appSwitcher',
    isTrial: boolean = false,
  ): void {
    this.track('DiscoveryTooltipCTAClick', {
      isTrial,
      productContext,
      context,
    });
  }

  public trackKiwiCtaClick(context: 'candidateProfile' | 'appSwitcher', isTrial?: boolean): void {
    this.trackTooltipEvents('DiscoveryTooltipCTAClick', 'kiwiHr', context, isTrial);
  }

  public trackKiwiSkipClick(context: 'candidateProfile' | 'appSwitcher', isTrial?: boolean): void {
    this.trackTooltipEvents('DiscoveryTooltipSkip', 'kiwiHr', context, isTrial);
  }

  public trackJourneysCtaClick(context: 'candidateProfile' | 'appSwitcher'): void {
    this.trackTooltipEvents('DiscoveryTooltipCTAClick', 'journeys', context);
  }

  public trackJourneysSkipClick(context: 'candidateProfile' | 'appSwitcher'): void {
    this.trackTooltipEvents('DiscoveryTooltipSkip', 'journeys', context);
  }

  public trackBookADemoClick(context: string): void {
    this.track('BookDemoClick', { context });
  }
}
